import apiDashboard from '../api/DashboardAPI';

const summary = async agentId => {
    const summary = await apiDashboard.summary(agentId);
    return summary;
};

const outdatedProperties = async agentId => {
    const outdatedProperties = await apiDashboard.outdatedProperties(agentId);
    return outdatedProperties;
};

const bestDealProperties = async agentId => {
    const bestDealProperties = await apiDashboard.bestDealProperties(agentId);
    return bestDealProperties;
};

const trialSummary = async agentId => {
    const trialSummary = await apiDashboard.trialSummary(agentId);
    return trialSummary;
};

export default {
    summary: summary,
    outdatedProperties: outdatedProperties,
    bestDealProperties,
    trialSummary,
};